import React from "react";
import PropTypes from "prop-types";
import { Field, getFormSyncErrors } from "redux-form";
import { useSelector } from "react-redux";
import { ReduxControls } from "rhombus-react";
import { required, maxLength } from "../validators/validators";
import { FEED_CREATION_FORM } from "forms/list";
import FeedSource from "./FeedSource";
import FeedSettings from "./FeedSettings";
import FeedEmail from "forms/contentfeeds/FeedEmail";
import ContentFeedFooter from "routes/contentfeeds/ContentFeedFooter";

import "./FeedCreationForm.css";

const FEED_NAME_MAX_LENGTH = 100;
const feedNameMaxLength = maxLength(FEED_NAME_MAX_LENGTH);

/**
 * Base form component for content feed operations
 * This component contains the common form fields and layout used across all content feed flows
 */
export default function BaseContentFeedForm(props) {
	const {
		onSubmit,
		onCancel,
		submitButtonTitle,
		reduxFormHandleSubmit,
		isSaveLoading,
		validationFields,
		showSourceFields = true,
		showSettingsFields = true,
		isAssignBlankFlow = false,
		isAssignFlow = false,
		children,
	} = props;

	const formSyncErrors = useSelector(state => getFormSyncErrors(FEED_CREATION_FORM)(state));
	const isFeedCreationFormInvalid = validationFields
		.some(fieldName => Boolean(formSyncErrors?.[fieldName]));

	return (
		<div className="feed-creation-form-container">
			<form className="feed-creation-form">
				<div className="form-field">
					<Field
						name="feedName"
						label="Bulk Sheet Name"
						component={ReduxControls.Input}
						required
						validate={[required, feedNameMaxLength]}
						placeholder="Enter bulk sheet name"
						showCharCount
						charMax={FEED_NAME_MAX_LENGTH}
					/>
				</div>

				{showSourceFields && (
					<FeedSource isAssignBlankFlow={isAssignBlankFlow} />
				)}

				<FeedEmail allowMultiple />

				{showSettingsFields && (
					<FeedSettings isAssignBlankFlow={isAssignBlankFlow} isAssignFlow={isAssignFlow} />
				)}

				{children}
			</form>

			<ContentFeedFooter
				onSave={reduxFormHandleSubmit ? reduxFormHandleSubmit(onSubmit) : onSubmit}
				onCancel={onCancel}
				isSaveDisabled={isFeedCreationFormInvalid}
				isSaveLoading={isSaveLoading}
				saveTitle={submitButtonTitle || "Submit"}
				saveTheme="blue"
			/>
		</div>
	);
}

BaseContentFeedForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
	submitButtonTitle: PropTypes.string,
	reduxFormHandleSubmit: PropTypes.func,
	isSaveLoading: PropTypes.bool,
	validationFields: PropTypes.arrayOf(PropTypes.string).isRequired,
	showSourceFields: PropTypes.bool,
	showSettingsFields: PropTypes.bool,
	isAssignBlankFlow: PropTypes.bool,
	isAssignFlow: PropTypes.bool,
	children: PropTypes.node,
};
